import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import logdown from 'logdown';

// ログの設定
window.logger = logdown("ganmodoki");
window.logger.state.isEnabled = true
// レベル log, warn, info , error


Vue.config.productionTip = false

if (!window.app){
  window.app = {};
}

// --------------------------------------------
// EventHubの設定
// --------------------------------------------
import eventHub from './plugins/EventHub';
Vue.use(eventHub);


// --------------------------------------------
// axios
// --------------------------------------------
Vue.prototype.$http = axios;

axios.interceptors.request.use(request => {
  console.log('Starting Request: ', request)
  return request
})

axios.interceptors.response.use(response => {
  console.log('Response: ', response)
  return response
})


// --------------------------------------------
// 共通コンポーネントの読み込み
// --------------------------------------------
import DateInputField from "./components/DateInputField";
Vue.component("date-input-field",DateInputField);

import PriorityChip from "@/components/parts/PriorityChip";
Vue.component("priority-chip",PriorityChip);

import ContractorChip from "@/components/parts/ContractorChip";
Vue.component("contractor-chip",ContractorChip);

import ImageView from "@/components/parts/ImageView";
Vue.component("image-view",ImageView);

import FileCard from "@/components/parts/FileCard";
Vue.component("file-card",FileCard);

import ProgressView from "@/components/parts/ProgressView";
Vue.component("progress-view",ProgressView);

// 共通CSSの読み込み
import "./ganmodoki.scss"


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


// 設定ファイルの選択をログ
console.log("ENV_NAME=" + process.env.VUE_APP_ENV_NAME);